import React, { useState } from "react";
import { Card, Avatar, Row, Col, Tooltip } from "antd";
import moment from "moment";
import {
  BankOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  IdcardOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import "./ProfileWidget.css";

const mockProfile = {
  name: "Sarah Johnson",
  pin: "EMP-2024-0042",
  designation: "Senior Software Engineer",
  department: "Engineering",
  dateOfJoining: "15 Jan 2021",
  dateOfConfirmation: "15 Jul 2021",
  age: 32,
  employmentStatus: "Permanent",
  location: "New York, USA",
  imageUrl: "",
};

function InfoItem({ icon: Icon, label, value, truncate }) {
  const valueContent =
    truncate && value ? (
      <Tooltip title={value}>
        <span className="profile-widget__info-value-truncate">{value}</span>
      </Tooltip>
    ) : (
      value
    );
  return (
    <Col xs={12} md={6} className="profile-widget__info-item-wrap">
      <div className="profile-widget__info-item-inner">
        <div className="profile-widget__info-icon-box">
          <Icon />
        </div>
        <div className="profile-widget__info-text">
          <p className="profile-widget__info-label">{label}</p>
          <p className="profile-widget__info-value">{valueContent}</p>
        </div>
      </div>
    </Col>
  );
}

export function ProfileWidget({profileData}) {
  console.log('profileData',profileData);
  const [profile] = useState(profileData[0]);
  console.log('profile',profile);
  const [imagePreview, setImagePreview] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // const initials = profile.name
  //   .split(" ")
  //   .map((n) => n[0])
  //   .join("");
  const initials = 'Brac';

  return (
    <div className="profile-widget">
      <div className="profile-widget__card">
        <div className="profile-widget__gradient-header" />
        <div className="profile-widget__card-body">
          <Row gutter={[0, 0]} className="profile-widget__profile-row">
            <Col xs={24} sm="auto">
              <div className="profile-widget__avatar-wrap">
                <Avatar
                  size={96}
                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}${profile.imageurl}${process.env.REACT_APP_IMAGE_TOKEN_KEY}`}
                  style={{
                    backgroundColor: "#1890ff",
                    fontSize: 28,
                    color: "#fff",
                  }}
                >
                  {!imagePreview && !profile.imageurl ? initials : null}
                </Avatar>
                <label className="profile-widget__avatar-overlay">
                  <CameraOutlined />
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                  />
                </label>
              </div>
            </Col>
            <Col xs={24} sm flex="1">
              <div className="profile-widget__name-and-status">
                <div className="profile-widget__name-block">
                  <div className="profile-widget__name-row">
                    <h2 className="profile-widget__name">{profile.name}</h2>
                    <span className="profile-widget__pin-badge">{profile.pin}</span>
                  </div>
                  <p className="profile-widget__designation">
                    {profile.designation}
                  </p>
                </div>
                <div className="profile-widget__status-badge-wrap">
                  <span className="profile-widget__status-badge">
                    {profile.employmentstatus}
                  </span>
                </div>
              </div>
            </Col>
          </Row>

          <div className="profile-widget__info-section">
            <Row gutter={[16, 0]} className="profile-widget__info-grid">
              <InfoItem
                icon={BankOutlined}
                label="Department"
                value={profile.department}
              />
              <InfoItem
                icon={EnvironmentOutlined}
                label="Location"
                value={profile.location}
                truncate
              />
              <InfoItem
                icon={CalendarOutlined}
                label="Date of Joining"
                value={
                  profile.dateofjoining
                    ? moment(profile.dateofjoining).format("DD MMM YYYY")
                    : ""
                }
              />
              <InfoItem
                icon={IdcardOutlined}
                label="Age"
                value={`${profile.age} years`}
              />
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}
